import React from "react";
import { Slider } from "@/components/ui/slider";
import { Badge } from "@/components/ui/badge";
import { formatStepValue, snapToStep } from "@/utils/voice";

interface CustomSliderProps {
  heading?: string;
  subheading?: string;
  value: number[];
  onChange: (value: number[]) => void;
  min?: number;
  max?: number;
  /** Increment from provider params_schema.step */
  step?: number;
  unit?: string;
  showValue?: boolean;
  disabled?: boolean;
}

export const VoiceSlider: React.FC<CustomSliderProps> = ({
  heading,
  subheading,
  value,
  onChange,
  min = 0,
  max = 2,
  step = 0.1,
  unit = "sec",
  showValue = true,
  disabled = false,
}) => {
  const handleChange = (next: number[]) => {
    const snapped = snapToStep(next[0], step, min, max);
    onChange([snapped]);
  };

  return (
    <div className="p-3 bg-muted rounded-xl space-y-1">
      {(heading || subheading) && (
        <div className="flex gap-1 flex-col sm:flex-row">
          {heading && (
            <span className="text-sm font-medium text-foreground">
              {heading}
            </span>
          )}
          {subheading && (
            <span className="text-xs text-muted-foreground">{subheading}</span>
          )}
        </div>
      )}

      <div className="rounded-lg">
        <div className="flex flex-col sm:flex-row sm:gap-4 sm:items-center">
          <div className="flex-1 py-1">
            <Slider
              value={value}
              onValueChange={handleChange}
              min={min}
              max={max}
              step={step}
              disabled={disabled}
              className="w-full"
            />
            <div className="flex justify-between mt-2">
              <span className="text-xs font-medium text-muted-foreground">
                {formatStepValue(min, step)}
                {unit ? ` (${unit})` : ""}
              </span>
              <span className="text-xs font-medium text-muted-foreground">
                {formatStepValue(max, step)}
                {unit ? ` (${unit})` : ""}
              </span>
            </div>
          </div>
          {showValue && (
            <Badge
              variant="outline"
              className="h-10 sm:w-20 w-24 bg-white dark:bg-black rounded-md flex items-center justify-center mt-3 sm:mt-0"
            >
              {formatStepValue(value[0], step)}
              {unit ? ` (${unit})` : ""}
            </Badge>
          )}
        </div>
      </div>
    </div>
  );
};
